import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_MEMBERS_BY_VID = createAsyncActionTypes('FETCH_MEMBERS_BY_VID');